import Loader from "../Loader/Loader";

export default function ExportLoaderAndText() {
    return (
        <div className="flex flex-col justify-center gap-y-[--spacing-items] items-center">
            <Loader wrapperClassName="h-[80px]" />
            <div>Please wait while the export is in progress.</div>
        </div>
    );
}
